if (!customElements.get('mini-cart')) {  
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.cartModalOpen = false;
    }

    connectedCallback() {
      this.cartUrl = this.dataset.cartUrl;
      this.sectionId = this.dataset.sectionId;
      this.cart = JSON.parse(this.dataset.cartJson) || null;
      this.classList.remove('loading');
      
      
      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
      document.addEventListener("update-cart-items", this.updateItems.bind(this));
      if (document.readyState === 'complete') this.init();
    }
    
    init() {
      this.addDelegatedClickListeners();
      this.getRecommendedProducts();
    }
    
    addDelegatedClickListeners() { 
      window.addEventListener('click', (e) => {
        if (!this.isConnected) return;
        if (window.location.pathname === this.cartUrl) return;

        if (e.target.closest('quickview-modal') && this.cartModalOpen) {
            return;
        }
        if (e.target.closest(`[href="${this.cartUrl}"]`)) {
            e.preventDefault();
            this.open();
            return;
        }
        if (e.target.closest('[data-close-cart]') && this.cartModalOpen) {
            this.close();
            return;
        }
        if (!e.target.closest('mini-cart') && this.cartModalOpen && !e.target.dataset.action) {
            this.close();
            return;
        }
      });

      window.addEventListener('submit', (e) => {
        const productForm = e.target.closest('[action="/cart/add"]');
        if(!productForm) return;

        e.preventDefault();

        let selling_plan = null;
        if (productForm.querySelector('[name="selling_plan"]') && productForm.querySelector('[name="selling_plan"]').value !== undefined) selling_plan = productForm.querySelector('[name="selling_plan"]').value;

        let discount = null;
        if (productForm.querySelector('[name="properties[Discount]"]') && productForm.querySelector('[name="properties[Discount]"]').value !== undefined) discount = productForm.querySelector('[name="properties[Discount]"]').value;

        const idToAdd = productForm.querySelector('[name="id"]').value;
        const propertyInputs = productForm.querySelectorAll('[data-form-property]');
        const recipientInputs = [...productForm.querySelectorAll(`[data-form-recipient]`)];
        const properties = {};

        if (propertyInputs) {
          for (let input of propertyInputs) {
            const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
            const val = input.value;

            properties[key] = val;
          }
        }

        if (recipientInputs.length > 0) {
          const controlFlag = recipientInputs.find((el) => el.getAttribute(`name`) === `properties[__shopify_send_gift_card_to_recipient]`);
          if (controlFlag.checked) {
            for (let input of recipientInputs) {
              const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
              const val = input.value;
  
              properties[key] = val;
            }
          }
        }

        this.classList.add('loading');
        this.addToCart(idToAdd, selling_plan, discount, properties)
          .then(() => {
            this.open();
          })
          .finally(() => this.classList.remove('loading'));
      });

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-cart-action]');
        if (!clickedElement) return;

        const {
          cartAction: action,
          lineItemId,
          capsuleId,
          quantity,
        } = clickedElement.dataset;
        
        switch (action) {
          case 'updateQty':
            const scrollTop = this.querySelector('form').scrollTop;
            this.classList.add('loading');

            if (capsuleId) {
              const capsuleProducts = this.cart.items.filter((item) => {
                return item.properties.find((property) => {
                  const capsuleItem = property.find((x) => x === capsuleId);
                  return capsuleItem;
                });
              });
                            
              this.bulkUpdateQty(capsuleProducts, Number(quantity))
                .then((res) => {
                  if (!res) return;
                  this.updateCartHtml(res).then(() => {
                    this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
                  });
                  this.getRecommendedProducts();
                })
                .finally(() => this.classList.remove('loading'));
              return;
            }
            
            this.updateQty(lineItemId, Number(quantity))
              .then((res) => {
                if (!res) return;
                this.updateCartHtml(res).then(() => {
                  this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
                });
                this.getRecommendedProducts();
              }).finally(() => this.classList.remove('loading'));
          break;
          default: break;
        }
      })
    }
    
    open() {
      this.cartModalOpen = true;
      this.classList.remove('translate-x-full');
      document.querySelector('.section-header').classList.replace('z-10', 'z-[5]');
      if (!window.location.href.includes('/cart')) document.body.classList.add('overlay')
      const quickView = document.querySelector('quickview-modal');
      if (quickView.isOpen) quickView?.close();
    }

    close() {
      this.cartModalOpen = false;
      this.classList.add('translate-x-full');
      document.querySelector('.section-header').classList.replace('z-[5]', 'z-10');
      document.body.classList.remove('overlay');
    }
    
    getRecommendedProducts() {
      if (!this.cart?.items.length) return;
      const recommendationsWrapper = this.querySelector('[data-recommended-product-row]');
      if (!recommendationsWrapper) return;
      
      const reccsToRenderPerCartItem = Math.round(5/this.cart.items.length);
            
      for (let i = 0; i < this.cart.items.length; i++) {
        const item = this.cart.items[i];
        fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${item.product_id}`)
          .then(response => {
            return response.json()
          })
          .then(({ products }) => {
            const filteredReccs = products
              .filter(({ id, tags }) => {
                return !this.cart.items.find(({ product_id }) => id == product_id) 
                && !tags.some(tag => tag === ('hide_product' || 'base_product'))
              })
              .slice(0, reccsToRenderPerCartItem)
            
              recommendationsWrapper.innerHTML += filteredReccs.map((recc) => {
                return `
                  <swiper-element>
                    <intersection-loader 
                      data-url="/products/${recc.handle}" 
                      data-section-id="product-tile"
                      data-recommended-url="${recc.url}"
                    ></intersection-loader>                    
                  </swiper-element>
                `;
              }).join('');
          })
      }         
    }

    async addToCart(id, selling_plan = null, discount = null, properties) {    
      const data = {
        id,
        'quantity': 1,
        sections: [`${this.sectionId}`]
      };

      if (properties && Object.keys(properties).length !== 0) {
        data['properties'] = properties;
        if (discount) data['properties']['Discount'] = discount;
      }

      if (selling_plan) data['selling_plan'] = selling_plan;

      const cartContents = fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.updateCartHtml(json);
          this.getRecommendedProducts();
        })
        .finally((res) => {
          // tracking would go here
        })
        .catch(function(err) {
          console.error(err)
        });

      return cartContents;
    }

    async updateCartHtml(res) {
      let newHtml = res?.sections?.[`${this.sectionId}`];
      if (!newHtml) {
        console.error('Something went wrong. Unable to update cart. Refresh to see updates.');
        return;
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtml;
      this.innerHTML = tempDiv.querySelector('mini-cart').innerHTML;
      const count = Number(tempDiv.querySelector('mini-cart').dataset.cartItemCount) || '';
      this.cart = JSON.parse(tempDiv.querySelector('mini-cart').dataset.cartJson) || null;
      [...document.querySelectorAll('[data-cart-count]')].forEach(cartCount => {
        cartCount.innerHTML = count > 0 ? count : '';
      });

      document.dispatchEvent(new CustomEvent('cart-updated', {
        detail: {
          cart: this.cart,
        }
      }));
    }
    
    async updateQty(id, qty) {
      const updates = {};
      updates[id] = qty;

      const data = {
        updates,
        sections: [`${this.sectionId}`],
      };

      const cartContents = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });

      return cartContents;
    };

    async updateItems(e) {
      const updates = e.detail.remove;
      const items = [{
        'id': Object.keys(e.detail.add)[0],
        'quantity': Object.values(e.detail.add)[0]
      }];
      const updateData = {
        updates,
        sections: [`${this.sectionId}`],
      };
      const addData = {
        items,
        sections: [`${this.sectionId}`],
      };

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      })
      .then((response) => response.json())
      .then(() => {
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
          },
          body: JSON.stringify(addData),
        })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.updateCartHtml(json);
          this.getRecommendedProducts();
          this.open();
        })
        .catch(function(err) {
          console.error(err)
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    };
    
    async bulkUpdateQty(items, qty) {
      const updates = {};
      
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        updates[item.id] = qty;
      }

      const data = {
        updates,
        sections: [`${this.sectionId}`],
      };

      const cartContents = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });

      return cartContents;
    };
  }

  customElements.define('mini-cart', MiniCart);
}